export default "__VITE_ASSET__BMmPIet6__"